import React, { useState } from "react";
import { connect } from 'react-redux';
import Tooltip from '../../../../../Shared/Tooltip/Tooltip';
import { getChartListAsync } from '../../../BusinessMonitoringChartsAsyncThunk';

const ResourceItem = (props) => {
    //const [isSelected, setIsSelected] = useState(false);

    return (
        <>
            <div className={`resource-item-wrapper`}>  
                <a className='text-wrapper' href='#' onClick={(e)=> handleItemClick(e, props.item)} id={`tooltip-resource-${props.item.id}`}>
                    <span>{props.item.displayName}</span>
                </a>                 
                <Tooltip text={getTooltipText(props.item)} target={`tooltip-resource-${props.item.id}`} placement={'top'} cellcomdefault={true} />
            </div>        
        </>
    );

    function handleItemClick(e, item) {
        e.preventDefault();
        //console.info('item', item);
        //setIsSelected(true);

        const data = {
            nvId: item?.nvId,
            serviceCode: item?.serviceCode,
            resourceid: item?.id,
            ifName: item?.ifName,
            hostName: item?.hostName,    
            metric: item?.metric,
            resolution: 'H',
            startDate: '',
            endDate: '',
            graphDataType: 'A'
        }
        props.getChartListAsync(data);
    }

    function getTooltipText(item) {
        const htmlString = `
            <div>
                <div> קוד קו: ${item.serviceCode} </div>
                <div> שם: ${item.name} </div>
                <div> רוחב פס: ${item.speed} </div>            
            </div>
        `;         
        return htmlString;
    }

};

const mapStateToProps = (state) => {
    return {
        isAdminMode: state.businessMonitoringChartsBlock.isAdminMode
    };
};
  
const mapDispatchToProps = { getChartListAsync };
  
export default connect(mapStateToProps, mapDispatchToProps)(ResourceItem);
